import React, { useState } from 'react'
import { Formik } from 'formik'
import get from 'lodash/get'
import * as Yup from 'yup'
import { t } from '../../i18n'

const SauceDosingModeForm = ({
  dosingMode = {
    name: '',
    dosing_pressure_fast: 0,
    dosing_pressure_slow: 0,
  },
  onSubmitForm
}) => {

  const validationSchema = Yup.object({
    name: Yup.string().required(t('sauce_dosing_modes.validations.name')),
    dosing_pressure_fast: Yup.number()
      .required(t('sauce_dosing_modes.validations.dosing_pressure_fast.required'))
      .min(0.1, t('sauce_dosing_modes.validations.dosing_pressure_fast.min', { min: 0.1 }))
      .max(2.0, t('sauce_dosing_modes.validations.dosing_pressure_fast.max', { max: 2.0 })),
    dosing_pressure_slow: Yup.number()
      .required(t('sauce_dosing_modes.validations.dosing_pressure_slow.required'))
      .min(0.1, t('sauce_dosing_modes.validations.dosing_pressure_slow.min', { min: 0.1 }))
      .max(2.0, t('sauce_dosing_modes.validations.dosing_pressure_slow.max', { max: 2.0 })),
  });

  return (
    <Formik
      initialValues={dosingMode}
      validationSchema={validationSchema}
      onSubmit={(values, { setStatus, setSubmitting }) => {
        const payload = { ...values }
        return onSubmitForm(payload, (success, errorData) => {
          let status = {}
          if (!success) {
            const fields = Object.getOwnPropertyNames(errorData.full_errors)
            for (let key in fields) {
              status[`${fields[key]}_error`] =
                errorData.full_errors[fields[key]].join(', ')
            }
          }
          setStatus(status)
          setSubmitting(false)
        })
      }}
    >
      {({
        values,
        errors,
        touched,
        status,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        setStatus,
      }) => {
        const enhancedHandleChange = (e) => {
          let newStatus = Object.assign({}, status)
          newStatus[`${e.target.name}_error`] = ''
          setStatus(newStatus)
          handleChange(e)
        }

        const renderField = (label, name, type, placeholder, value=null, inverted = true, autoComplete = 'off') => {
          const inputValue = value !== null ? value : values[name]
          const errorsPresent = get(errors, name) && get(touched, name)

          const errorMessage =
          typeof get(errors, name) === 'string'
            ? get(errors, name)
            : get(errors, name)?.required ||
              (status && status[`${name}_error`]);
          return (
            <div className="form-group">
              <label>{label}</label>
              <input
                id={name}
                name={name}
                type={type}
                onBlur={handleBlur}
                value={inputValue === null ? '' : inputValue}
                placeholder={placeholder}
                autoComplete={autoComplete}
                onChange={enhancedHandleChange}
                className={`form-control ${errorsPresent && 'is-invalid'} ${inverted && 'inverted'}`}
                step="any"
              />
              {errorsPresent && (
                <div className="invalid-feedback">
                   {errorMessage}
                </div>
              )}
            </div>
          )
        }

        return (
          <form onSubmit={handleSubmit} className="form-robis">
            {renderField(
              t('sauce_dosing_modes.name'),
              'name',
              'text',
              t('sauce_dosing_modes.enter_name')
            )}

            {renderField(
              t('sauce_dosing_modes.dosing_pressure_fast'),
              'dosing_pressure_fast',
              'number',
              t('sauce_dosing_modes.enter_dosing_pressure_fast'),
              values.dosing_pressure_fast
            )}

            {renderField(
              t('sauce_dosing_modes.dosing_pressure_slow'),
              'dosing_pressure_slow',
              'number',
              t('sauce_dosing_modes.enter_dosing_pressure_slow'),
              values.dosing_pressure_slow
            )}

            <div className="form-actions d-flex justify-content-end">
              <a className="btn btn-secondary inverted me-2" href="/admin/sauce_dosing_modes">
                {t('cancel')}
              </a>
              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                {t('save')}
              </button>
            </div>
          </form>
        )
      }}
    </Formik>
  )
}

export default SauceDosingModeForm
